import { useContext, useEffect, useState } from 'react';
import Checkbox from '../../../../components/Checkbox/Checkbox';
import Input from '../../../../components/Inputs/Input';
import './StoresForm.css';
import Select, { Option } from '../../../../components/Inputs/Select';
import coloredWarningImage from '../../../../assets/Icons/colored-warning.svg';

import { createPart, getDropdownConfiguration, getPartInfo } from '../../services/PartsConfigurationService';
import { Dropdowns } from '../../../../components/Dropdowns/Dropdowns';
import CheckboxField from '../../../../components/Checkbox/CheckboxField';
import MultioptionButton from '../../../../components/Buttons/MultioptionButton';
import { PartConfigurationContext } from '../../contexts/PartConfigurationContext';
import { useSnackBar } from '../../../../hooks/useSnackBar';
import { DropdownsContext, useDropdownConfig } from '../../../../contexts/DropdownsContext';
import { usePermissions } from '../../../../hooks/usePermissions';
import { localStorageGet, localStorageSave } from '../../../../services/localStorageService';
import { useDispatch, useSelector } from 'react-redux';
import { closeDraft, selectNewParts } from '../../../../redux/features/configuration/parts/partsConfigurationSlice';
import { createStoresInfo, getStoresInfo, updateStoresInfo } from '../../services/StoresService';
import { HTTP_RESPONSE_CODES } from '../../../../globals/globals';
import { SectionPlaceholder } from './SectionPlaceholder';
import engineeringImg from '../../../../assets/Images/engineering-placeholder.svg';


// const dropdownIds = [4, 5, 6, 7];
const ATADropdowns = [8, 9, 10];
const otherDropdowns = [4, 5, 6, 7];
const requiredDropdowns = [4, 5, 7];
const dropdownNames = { 4: 'categoryId', 5: 'subCategoryId', 6: 'dimensionUomId', 7: 'manufacturerId', 8: "atachapterId", 9: "atasectionId", 10: "ataparagraphId" };
const requiredFields = {
  ...Object.fromEntries(requiredDropdowns.map(id => [dropdownNames[id], true])),
  "partNumber": true,
  "name": true,
  "description": true,
}

const defaultEmptyValues = {
  name: "",
  partNumber: "",
  description: "",
  categoryId: null,
  subCategoryId: null,
  atachapterId: null,
  atasectionId: null,
  ataparagraphId: null,
  pmaStatus: false,
  receivingInpsection: false,
  dimensionUomId: "",
  hazardousMaterial: false,
  manufacturerId: null,
  partType: " "
};
const hideFieldsWhenDisabled = new Set(["categoryId", "subCategoryId", "ATAChapter", "ATASection", "ATAParagraph"]);
const localStoragePrefix = 'configuration/parts/stores';
const fieldChangeMapper = {
  categoryId: (completeValue) => ({ categoryId: completeValue.id, subCategoryId: null }),
  subCategoryId: (completeValue) => ({ subCategoryId: completeValue.id }),
  atachapterId: (completeValue) => ({ atachapterId: completeValue.id, atasectionId: null, ataparagraphId: null }),
  atasectionId: (completeValue) => ({ atasectionId: completeValue.id, ataparagraphId: null })
}



const generalSectionButtons = [
  { label: 'Save and Finish', icon: "icon-save", id: 'save' },
  { label: 'Save and Continue Editing', icon: "icon-save", id: 'save-continue' },
  { label: 'Cancel', icon: "icon-cross", id: 'cancel', type: 'danger' }
];


const StoresForm = ({ onChange, open, part, disabled }) => {

  const [editing, setEditing] = useState(false);
  const [errorState, setErrorState] = useState({});
  const dimensionUom = useDropdownConfig(80);
  const weightUom = useDropdownConfig(81);

  const {infoMsg, successMsg, warningMsg} = useSnackBar();

  //FIXME: use actual permission context;


  //Form

  const [values, setValues] = useState({
    length: "",
    width: "",
    depth: "",
    dimensionUnit: null,
    weight: "",
    weightUnit: "",
    totalTimeHours: "",
    totalTimeCycles: "",
    totalTimeDays: "",
    binControl: false,
  })
  const [backup, setBackup] = useState({
    length: "",
    width: "",
    depth: "",
    dimensionUnit: null,
    weight: "",
    weightUnit: "",
    totalTimeHours: "",
    totalTimeCycles: "",
    totalTimeDays: "",
    binControl: false,
  })

  const hasPermission = () => {
    return true;
  }

  const saveSection = async (closeEdition) => {
    infoMsg("Saving stores information");
    if (typeof (values.id) !== 'number') {
      let postResponse = await createStoresInfo({ ...values, part }, part.id);
      if (postResponse.data.responseCode === HTTP_RESPONSE_CODES.CREATED) {
        updateStoresInfo({ ...postResponse.data.load, ...values, part }, part.id).then(updateResponse => {
          if (updateResponse.data.responseCode === HTTP_RESPONSE_CODES.UPDATED) {
            successMsg("Stores information saved");
            setValues(updateResponse.data.load);
            setBackup(updateResponse.data.load);
            if (closeEdition) setEditing(false);
          }
          else {
            warningMsg(updateResponse.data.message, updateResponse.data.validationErrors?.map(e => e.error).join(', '))
          }
        });
      }
    } else {
      updateStoresInfo({ ...values, part }, part.id).then(updateResponse => {
        if (updateResponse.data.responseCode === HTTP_RESPONSE_CODES.UPDATED) {
          successMsg("Finance information saved");
          setValues(updateResponse.data.load);
          setBackup(updateResponse.data.load);
          if (closeEdition) setEditing(false);
        } else {
          warningMsg(updateResponse.data.message, updateResponse.data.validationErrors?.map(e => e.error).join(', '))
        }
      });
    }
  }

  const cancelEdit = () => {
    setValues(backup);
    setEditing(false);
  }

  const changeValue = (e) => {
    let { name, value } = e;
    setValues(prev => ({ ...prev, [name]: value }));
  }

  const handleDropdown = (opt, name) => {
    changeValue({ name, value: opt.id });
    // TODO: handle clear dropdowns;

  }

  useEffect(() => {
    if (open && part) {
      getStoresInfo(part.id).then(response => {
        if (response.data.responseCode === HTTP_RESPONSE_CODES.SUCCESS) {
          if (response.data.load) {
            setValues(response.data.load);
          }
        }
      })
    }
  }, [open, part])


  return (open &&
    <div className='general-section-form-wrapper'>
      <div className='section-header'>
        <div className='title-container'>
          <b>Stores</b>
          {!editing && hasPermission('update') && (part?.version > 0)  && <button className='outlined iconTextButton small-size' onClick={() => setEditing(true)}>
            <i className='icon-edit'></i>
            <span>
              Edit
            </span>
          </button>}
        </div>
        {editing && hasPermission('update') && <MultioptionButton buttonCallbacks={{
          'save': () => saveSection(true),
          'save-continue': () => saveSection(false),
          'cancel': () => cancelEdit()
        }} buttons={generalSectionButtons} />}
      </div>
      {part?.version > 0 ? <div className='stores-form-grid'>
        {/* <b className='subtitle'>Dimensions</b> */}
        <div className='dimensions-grid'>
          <Input value={values.length} isNumeric error={errorState["length"]} disabled={!editing} name="length" label={"Length"} onChange={(e) => changeValue(e.target)} />
          <i className='icon-light-cross'></i>
          <Input value={values.width} isNumeric error={errorState["width"]} disabled={!editing} name="width" label={"Width"} onChange={(e) => changeValue(e.target)} />
          <i className='icon-light-cross'></i>
          <Input value={values.depth} isNumeric error={errorState["depth"]} disabled={!editing} name="depth" label={"Depth"} onChange={(e) => changeValue(e.target)} />
        </div>
        <Dropdowns preSelectValue={values.dimensionUnit} onOptionSelect={(opt) => handleDropdown(opt, "dimensionUnit")} optionLabel="name" disabled={!editing} data={dimensionUom.config} />
        <Input localizedFormat value={values.weight} isNumeric error={errorState["weight"]} disabled={!editing} maxLength="50" name="weight" label={"Weight"}  onChange={(e) => changeValue(e.target)} />
        <Dropdowns preSelectValue={values.weightUnit} onOptionSelect={(opt) => handleDropdown(opt, "weightUnit")} optionLabel="name" disabled={!editing} data={weightUom.config} />
        <div className='bin-control'>
          <CheckboxField checked={values.binControl} onChange={(e) => changeValue({ name: "binControl", value: e })} disabled={!editing}> Bin Control </CheckboxField>
          <b className='subtitle'>Total Time</b>
        </div>
        <div className='schedule'>
          <Input isNumeric value={values.totalTimeHours} error={errorState["Hours"]} disabled={!editing} name="totalTimeHours" label={"Hours"} onChange={(e) => changeValue(e.target)} />
          <Input isNumeric value={values.totalTimeCycles} error={errorState["Cycles"]} disabled={!editing} name="totalTimeCycles" label={"Cycles"}  onChange={(e) => changeValue(e.target)} />
          <Input isNumeric value={values.totalTimeDays} error={errorState["Days"]} disabled={!editing} name="totalTimeDays" label={"Days"}  onChange={(e) => changeValue(e.target)} />
        </div>

      </div> 
            : <SectionPlaceholder title="There are no configurations in this panel" subTitle="Save the General Information to enable this section" image={engineeringImg}/>
      
      }





      {/* <div className="stores-form">
        <Input error={errorState["length"]} disabled={!editing}  name="length" label={"Length"} onChange={()=>{}} />
        <i className='icon-light-cross'></i>
        <Input error={errorState["width"]} disabled={!editing} name="width" label={"Width"} onChange={()=>{}} />
        <i className='icon-light-cross'></i>
        <Input error={errorState["depth"]} disabled={!editing} name="depth" label={"Depth"} onChange={()=>{}} />
        <Dropdowns optionLabel="name"  disabled={!editing} data={dimensionUom.config}/>
      </div>
      <div className='stores-aditional'>
        <Input error={errorState["weight"]} disabled={!editing} maxLength="50" name="weight" label={"Weight"} onChange={()=>{}} />
        <Dropdowns optionLabel="name"  disabled={!editing} data={weightUom.config} />
      </div> */}
    </div>
  )
}

export default StoresForm;